import axios from "axios";
import toast from "react-hot-toast";
import i18n from "../i18n";

const api = axios.create({
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

const privateApi = axios.create({
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

const auth = () => {
  try {
    return JSON.parse(localStorage.getItem("auth"));
  } catch {
    return null;
  }
};

const clearAuth = () => {
  localStorage.removeItem("auth");
};

let interceptorsInstalled = false;
let redirecting = false;

/**
 * Yetkili istekler için paylaşılan axios örneği. Yakalayıcılar yalnız bir kez
 * takılır; aksi halde her dilim kendi kopyasını ekliyor ve 401'de uyarı
 * dilim sayısı kadar yineleniyordu.
 */
export const axiosPrivate = () => {
  if (interceptorsInstalled) return privateApi;
  interceptorsInstalled = true;

  privateApi.interceptors.request.use(
    (config) => {
      if (!config.headers["Authorization"]) {
        const token = auth()?.token;
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  privateApi.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 && !redirecting) {
        redirecting = true;
        clearAuth();
        toast.error(i18n.t("errors.sessionExpired"), { position: "top-right" });
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );

  return privateApi;
};

export default api;
